import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X, Star, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { NavigationMenu } from './NavigationMenus';
import { Brand } from './Brand';
import { business, phoneHref } from '../../data/business';

const navigation = [['equipment', 'Equipment'], ['projects', 'Projects'], ['about', 'About Us'], ['contact', 'Contact']];

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const toggle = useRef(null);
  useEffect(() => setOpen(false), [location.pathname, location.search]);
  const closeOnEscape = event => {
    if (event.key === 'Escape' && open) { setOpen(false); toggle.current?.focus(); }
  };
  return <header className="interior-header" data-testid="interior-header" onKeyDown={closeOnEscape}>
    <div className="interior-topbar"><div className="site-container topbar-inner">
      <Link to="/service-areas/" className="topbar-region" data-testid="topbar-service-areas"><Star size={21} aria-hidden="true" /><span>SERVING NORTH TEXAS</span></Link>
      <span className="topbar-cities" data-testid="topbar-cities">DALLAS <span aria-hidden="true">◆</span> FORT WORTH <span aria-hidden="true">◆</span> SURROUNDING AREAS</span>
      <a href={phoneHref} className="topbar-phone" data-testid="interior-top-phone"><Phone size={19} aria-hidden="true" />{business.phoneDisplay}</a>
    </div></div>
    <div className="site-container header-inner"><Brand />
      <Button ref={toggle} variant="ghost" className="mobile-menu-toggle" data-testid="mobile-menu-toggle" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="interior-navigation" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</Button>
      <nav id="interior-navigation" className={`interior-navigation ${open ? 'is-open' : ''}`} aria-label="Main navigation" data-testid="interior-navigation">
        <NavigationMenu kind="services" />
        {navigation.map(([path, label]) => <NavLink key={path} to={`/${path}/`} data-testid={`interior-nav-${path}`}>{label}</NavLink>)}
        <NavigationMenu kind="work" />
        <Link className="site-button nav-quote" to="/request-a-quote/" data-testid="interior-nav-quote">Request a Quote <ArrowUpRight size={17} aria-hidden="true" /></Link>
      </nav>
    </div>
  </header>;
};